// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * # Constraints Panel Styles
 *
 * Dark-theme styling for the constraint groups and match cards.
 * Uses IDE CSS variables for consistency with the rest of the app.
 */

/* Match card: compact row with coloured left border */
.constraint-match-card {
  border-left: 3px solid var(--color-ide-accent, #569cd6);
  background-color: var(--color-ide-surface-2);
  border-radius: 3px;
  padding: 4px 8px;
  cursor: pointer;
  transition: background-color 0.1s;
  user-select: none;
}

.constraint-match-card:hover {
  background-color: #353535;
}

/* Selected constraint match */
.constraint-match-card.constraint-selected {
  background-color: rgba(86, 156, 214, 0.15);
  border-left-color: var(--color-ide-accent-bright, #79b8ff);
}

.constraint-match-card.constraint-selected:hover {
  background-color: rgba(86, 156, 214, 0.22);
}

/* Group section: collapsible area */
.constraint-group-header {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.1s;
  border-radius: 3px;
}

.constraint-group-header:hover {
  background-color: var(--color-ide-surface-2);
}

/* Direction badge: small pill showing vertical/horizontal */
.constraint-direction-badge {
  font-size: 9px;
  padding: 1px 5px;
  border-radius: 3px;
  background-color: var(--color-ide-hover-overlay);
  color: var(--color-ide-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.4;
}

/* Type label on match cards */
.constraint-type-label {
  font-size: 9px;
  padding: 1px 5px;
  border-radius: 3px;
  background-color: var(--color-ide-hover-overlay);
  color: var(--color-ide-text-muted);
  text-transform: lowercase;
  letter-spacing: 0.3px;
}

/* Arrow separator between instance sets */
.constraint-arrow {
  color: var(--color-ide-text-dim);
  font-size: 11px;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/ConstraintsPanel/constraintsPanel.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF,sDAAsD;AACtD;EACE,uDAAuD;EACvD,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,0CAA0C;EAC1C,0DAA0D;AAC5D;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,4DAA4D;AAC5D;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gDAAgD;EAChD,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB","sourcesContent":["/*\n * # Constraints Panel Styles\n *\n * Dark-theme styling for the constraint groups and match cards.\n * Uses IDE CSS variables for consistency with the rest of the app.\n */\n\n/* Match card: compact row with coloured left border */\n.constraint-match-card {\n  border-left: 3px solid var(--color-ide-accent, #569cd6);\n  background-color: var(--color-ide-surface-2);\n  border-radius: 3px;\n  padding: 4px 8px;\n  cursor: pointer;\n  transition: background-color 0.1s;\n  user-select: none;\n}\n\n.constraint-match-card:hover {\n  background-color: #353535;\n}\n\n/* Selected constraint match */\n.constraint-match-card.constraint-selected {\n  background-color: rgba(86, 156, 214, 0.15);\n  border-left-color: var(--color-ide-accent-bright, #79b8ff);\n}\n\n.constraint-match-card.constraint-selected:hover {\n  background-color: rgba(86, 156, 214, 0.22);\n}\n\n/* Group section: collapsible area */\n.constraint-group-header {\n  cursor: pointer;\n  user-select: none;\n  transition: background-color 0.1s;\n  border-radius: 3px;\n}\n\n.constraint-group-header:hover {\n  background-color: var(--color-ide-surface-2);\n}\n\n/* Direction badge: small pill showing vertical/horizontal */\n.constraint-direction-badge {\n  font-size: 9px;\n  padding: 1px 5px;\n  border-radius: 3px;\n  background-color: var(--color-ide-hover-overlay);\n  color: var(--color-ide-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  line-height: 1.4;\n}\n\n/* Type label on match cards */\n.constraint-type-label {\n  font-size: 9px;\n  padding: 1px 5px;\n  border-radius: 3px;\n  background-color: var(--color-ide-hover-overlay);\n  color: var(--color-ide-text-muted);\n  text-transform: lowercase;\n  letter-spacing: 0.3px;\n}\n\n/* Arrow separator between instance sets */\n.constraint-arrow {\n  color: var(--color-ide-text-dim);\n  font-size: 11px;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
